import { render, staticRenderFns } from "./NewRowTwoTag.vue?vue&type=template&id=6f0db4e6&"
import script from "./NewRowTwoTag.vue?vue&type=script&lang=js&"
export * from "./NewRowTwoTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0db4e6')) {
      api.createRecord('6f0db4e6', component.options)
    } else {
      api.reload('6f0db4e6', component.options)
    }
    module.hot.accept("./NewRowTwoTag.vue?vue&type=template&id=6f0db4e6&", function () {
      api.rerender('6f0db4e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/homepage/NewRowTwoTag.vue"
export default component.exports